'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorState = require('prosemirror-state');

const createPlugins = module => {
  const eventHandler = (data, type) => {
    const editor = module.editor;

    if (editor) {
      editor.emit(type, data);
    }

    return false;
  };

  const plugin = new prosemirrorState.Plugin({
    key: new prosemirrorState.PluginKey("core"),
    state: {
      init() {
        return 0;
      },

      apply(tr) {
        eventHandler(tr, "update");

        if (tr.docChanged) {
          eventHandler(tr, "change");
        }

        return 0;
      }

    },
    props: {
      handleClick: (v, p, e) => eventHandler(e, "click"),
      handleDoubleClick: (v, p, e) => eventHandler(e, "doubleClick"),
      handleTripleClick: (v, p, e) => eventHandler(e, "tripleClick"),
      handleKeyDown: (v, e) => eventHandler(e, "keydown"),
      handleKeyPress: (v, e) => eventHandler(e, "keypress"),
      handleTextInput: (v, f, t, text) => eventHandler(text, "textinput"),
      handleScrollToSelection: () => eventHandler(null, "scrolltoslelection"),
      handlePaste: (v, e, slice) => eventHandler({
        event: e,
        slice
      }, "paste"),
      handleDrop: (v, e, slice) => eventHandler({
        event: e,
        slice
      }, "drop")
    },
    view: () => ({
      destroy: () => eventHandler(null, "destroy")
    })
  });
  return [plugin];
};

class CoreModule {
  constructor() {
    this.name = "core";
    this.plugins = [];
    this.editor = null;
    this.plugins = createPlugins(this);
  }

  init(editor) {
    this.editor = editor;
  }

}
CoreModule.moduleName = "core";

exports.CoreModule = CoreModule;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/core/index.js